import { createFileRoute } from '@tanstack/react-router'
import { AlertsPage } from 'pages/alerts/Alerts'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { alertsSearchSchema } from 'routes/alerts/-searchParams'

const RouteComponent = () => {
  const searchParams = Route.useSearch()

  return (
    <AlertsPage
      siteId={searchParams[SEARCH_PARAM_SITE_ID]}
      allSearchParams={searchParams}
    />
  )
}

export const Route = createFileRoute('/alerts/')({
  component: RouteComponent,
  validateSearch: alertsSearchSchema,
  staticData: {
    title: 'Alerts',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
    },
  },
})
